import { LOAD_PERMISSIONS } from "./types";

export const loadPermissions = () => ({
  type: LOAD_PERMISSIONS
});